import {
  convertMsToSeconds as h,
  dateFromUnixTimestamp as l,
} from "../../util/date-utils.js";
import { FEED_ANIMATION_DURATION as u } from "../../common/constants.js";
import E from "../../managers/subscription-manager.js";
export default class Card {
  constructor(t, i, s, h, n, l, e, r, u, E, o, T, I, a, N, c) {
    (this.id = t),
      (this.viewed = i),
      (this.title = s),
      (this.imageUrl = h),
      (this.description = n),
      (this.created = l),
      (this.updated = e),
      (this.categories = r),
      (this.expiresAt = u),
      (this.url = E),
      (this.linkText = o),
      (this.aspectRatio = T),
      (this.extras = I),
      (this.pinned = a),
      (this.dismissible = N),
      (this.clicked = c),
      (this.id = t),
      (this.viewed = i || !1),
      (this.title = s || ""),
      (this.imageUrl = h),
      (this.description = n || ""),
      (this.created = l || null),
      (this.updated = e || null),
      (this.categories = r || []),
      (this.expiresAt = u || null),
      (this.url = E),
      (this.linkText = o),
      null == T
        ? (this.aspectRatio = null)
        : ((T = parseFloat(T.toString())),
          (this.aspectRatio = isNaN(T) ? null : T)),
      (this.extras = I || {}),
      (this.pinned = a || !1),
      (this.dismissible = N || !1),
      (this.dismissed = !1),
      (this.clicked = c || !1),
      (this.isControl = !1),
      (this.test = !1),
      (this.ht = null),
      (this.nt = null);
  }
  subscribeToClickedEvent(t) {
    return this.et().lt(t);
  }
  subscribeToDismissedEvent(t) {
    return this.rt().lt(t);
  }
  removeSubscription(t) {
    this.et().removeSubscription(t), this.rt().removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.et().removeAllSubscriptions(), this.rt().removeAllSubscriptions();
  }
  dismissCard() {
    if (!this.dismissible || this.dismissed) return;
    "function" == typeof this.logCardDismissal && this.logCardDismissal();
    let t = this._;
    !t && this.id && (t = document.getElementById(this.id)),
      t &&
        ((t.style.height = t.offsetHeight + "px"),
        (t.className = t.className + " ab-hide"),
        setTimeout(function () {
          t &&
            t.parentNode &&
            ((t.style.height = "0"),
            (t.style.margin = "0"),
            setTimeout(function () {
              t && t.parentNode && t.parentNode.removeChild(t);
            }, Card.ut));
        }, u));
  }
  et() {
    return null == this.ht && (this.ht = new E()), this.ht;
  }
  rt() {
    return null == this.nt && (this.nt = new E()), this.nt;
  }
  M() {
    this.viewed = !0;
  }
  p() {
    (this.viewed = !0), (this.clicked = !0), this.et().Et();
  }
  F() {
    return (
      !(!this.dismissible || this.dismissed) &&
      ((this.dismissed = !0), this.rt().Et(), !0)
    );
  }
  ot(t) {
    if (null == t || t[Card.Tt.ns] !== this.id) return !0;
    if (t[Card.Tt.It]) return !1;
    if (
      null != t[Card.Tt.us] &&
      null != this.updated &&
      parseInt(t[Card.Tt.us]) < h(this.updated.valueOf())
    )
      return !0;
    if (
      (t[Card.Tt.ls] && !this.viewed && (this.viewed = !0),
      t[Card.Tt.ys] && !this.clicked && (this.clicked = t[Card.Tt.ys]),
      null != t[Card.Tt.st] && (this.title = t[Card.Tt.st]),
      null != t[Card.Tt.os] && (this.imageUrl = t[Card.Tt.os]),
      null != t[Card.Tt.it] && (this.description = t[Card.Tt.it]),
      null != t[Card.Tt.us])
    ) {
      const i = l(t[Card.Tt.us]);
      null != i && (this.updated = i);
    }
    if (null != t[Card.Tt.ds]) {
      let i;
      (i = t[Card.Tt.ds] === Card.Nt ? null : l(t[Card.Tt.ds])),
        (this.expiresAt = i);
    }
    if (
      (null != t[Card.Tt.URL] && (this.url = t[Card.Tt.URL]),
      null != t[Card.Tt.ps] && (this.linkText = t[Card.Tt.ps]),
      null != t[Card.Tt.fs])
    ) {
      const i = parseFloat(t[Card.Tt.fs].toString());
      this.aspectRatio = isNaN(i) ? null : i;
    }
    return (
      null != t[Card.Tt.xs] && (this.extras = t[Card.Tt.xs]),
      null != t[Card.Tt.gs] && (this.pinned = t[Card.Tt.gs]),
      null != t[Card.Tt.js] && (this.dismissible = t[Card.Tt.js]),
      null != t[Card.Tt.zs] && (this.test = t[Card.Tt.zs]),
      !0
    );
  }
  ss() {
    throw new Error("Must be implemented in a subclass");
  }
}
(Card.Nt = -1),
  (Card.Tt = {
    ns: "id",
    ls: "v",
    js: "db",
    It: "r",
    us: "ca",
    gs: "p",
    ds: "ea",
    xs: "e",
    ts: "tp",
    os: "i",
    st: "tt",
    it: "ds",
    URL: "u",
    ps: "dm",
    fs: "ar",
    ys: "cl",
    zs: "t",
  }),
  (Card.es = {
    tt: "captioned_image",
    ct: "text_announcement",
    St: "short_news",
    rs: "banner_image",
    At: "control",
  }),
  (Card.hs = {
    ns: "id",
    ls: "v",
    js: "db",
    cs: "cr",
    us: "ca",
    gs: "p",
    bs: "t",
    ds: "ea",
    xs: "e",
    ts: "tp",
    os: "i",
    st: "tt",
    it: "ds",
    URL: "u",
    ps: "dm",
    fs: "ar",
    ys: "cl",
    zs: "s",
  }),
  (Card.Dt = {
    dt: "ADVERTISING",
    Ct: "ANNOUNCEMENTS",
    Rt: "NEWS",
    bt: "SOCIAL",
  }),
  (Card.ut = 400);
